// src/apiConstants.js

const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';
export const API_BASE_URL = `${API_ROOT_URL.replace(/\/(banking|school)\/?$/, '').replace(/\/$/, '')}/school`;

export const API_LOGIN = `${API_BASE_URL}/login-school`;
export const API_CURRENT_SCHOOL_USER = `${API_BASE_URL}/current-user`;
export const API_DASHBOARD_SUMMARY = `${API_BASE_URL}/dashboard-summary`;

// // Define the endpoints for different API calls

export const API_ADD_STUDENT = `${API_BASE_URL}/add-student`;
export const API_UPDATE_STUDENT = `${API_BASE_URL}/update-student`;
export const API_GET_STUDENTS = `${API_BASE_URL}/students`;
export const API_STATUS_UPDATE = `${API_BASE_URL}/update-status`;
export const API_GET_STUDENT_DETAIL = `${API_BASE_URL}/student-detail`;
export const API_DELETE_STUDENT = `${API_BASE_URL}/delete-student`;
export const API_RESTORE_STUDENT = `${API_BASE_URL}/restore-student`;
export const API_PREVIEW_STUDENT_DOCUMENT = `${API_BASE_URL}/student-document-preview`;
export const API_STUDENT_REPORT_CARDS = `${API_BASE_URL}/student-report-cards`;
export const API_CREATE_STUDENT_REPORT_CARD = `${API_BASE_URL}/create-student-report-card`;
export const API_UPDATE_STUDENT_REPORT_CARD = `${API_BASE_URL}/update-student-report-card`;
export const API_ARCHIVE_STUDENT_REPORT_CARD = `${API_BASE_URL}/archive-student-report-card`;
export const API_RESTORE_STUDENT_REPORT_CARD = `${API_BASE_URL}/restore-student-report-card`;
export const API_STUDENT_REPORT_CARD_PREVIEW = `${API_BASE_URL}/student-report-card-preview`;
export const API_GET_ACADEMIC_SESSIONS = `${API_BASE_URL}/academic-sessions`;
export const API_MANAGE_ACADEMIC_SESSIONS = `${API_BASE_URL}/academic-session-management`;
export const API_SAVE_ACADEMIC_SESSION = `${API_BASE_URL}/save-academic-session`;
export const API_ARCHIVE_ACADEMIC_SESSION = `${API_BASE_URL}/archive-academic-session`;
export const API_PROMOTION_CANDIDATES = `${API_BASE_URL}/promotion-candidates`;
export const API_PROMOTE_STUDENTS = `${API_BASE_URL}/promote-students`;

export const API_ADD_FEE = `${API_BASE_URL}/add-fee`;
export const API_UPDATE_FEE = `${API_BASE_URL}/update-fee`;
export const API_CORRECT_POSTED_FEE = `${API_BASE_URL}/correct-posted-fee`;
export const API_GET_FEE_CORRECTIONS = `${API_BASE_URL}/fee-corrections`;
export const API_GET_FEES = `${API_BASE_URL}/fees`;
export const API_GET_UNASSIGNED_FEE_SESSIONS = `${API_BASE_URL}/unassigned-fee-sessions`;
export const API_GET_FEE_RECEIPTS = `${API_BASE_URL}/fee-receipts`;
export const API_ADD_FEE_RECEIPT = `${API_BASE_URL}/add-fee-receipt`;
export const API_VOID_FEE_RECEIPT = `${API_BASE_URL}/void-fee-receipt`;
export const API_REFUND_FEE_RECEIPT = `${API_BASE_URL}/refund-fee-receipt`;
export const API_GET_STUDENT_CHARGES = `${API_BASE_URL}/student-charges`;
export const API_ADD_STUDENT_CHARGE = `${API_BASE_URL}/add-student-charge`;
export const API_ARCHIVE_STUDENT_CHARGE = `${API_BASE_URL}/archive-student-charge`;
export const API_DELETE_FEE = `${API_BASE_URL}/delete-fee`;
export const API_GET_FEE_LEDGER = `${API_BASE_URL}/fee-ledger`;
export const API_ADD_FEE_LEDGER_ENTRY = `${API_BASE_URL}/add-fee-ledger-entry`;
export const API_RECEIPT_PRINT_AUDIT = `${API_BASE_URL}/receipt-print-audit`;

export const API_ADD_MISC_FEE = `${API_BASE_URL}/add-misc-fee`;
export const API_UPDATE_MISC_FEE = `${API_BASE_URL}/update-misc-fee`;

export const API_GET_MISC_FEES = `${API_BASE_URL}/misc-fees`;
export const API_DELETE_MISC_FEE = `${API_BASE_URL}/delete-misc-fee`;
export const API_GET_UNIFORM_PRICE_LIST = `${API_BASE_URL}/uniform-price-list`;

export const API_STUDENT_FEE_REPORTS = `${API_BASE_URL}/get-fees-report`;
export const API_MISC_FEE_REPORTS = `${API_BASE_URL}/get-misc-fees-report`;

export const API_ADD_CLASS_FEE_BOOK_PRICE = `${API_BASE_URL}/add-fee-book-master`;
export const API_GET_FEES_BOOKS_MASTER = `${API_BASE_URL}/get-fee-book-master`;
export const API_GET_FEE_BOOK_VERSIONS = `${API_BASE_URL}/fee-book-versions`;
export const API_SAVE_FEE_BOOK_VERSION = `${API_BASE_URL}/save-fee-book-version`;
export const API_ARCHIVE_FEE_BOOK_VERSION = `${API_BASE_URL}/archive-fee-book-version`;
export const API_COMPARE_FEE_BOOK_VERSIONS = `${API_BASE_URL}/compare-fee-book-versions`;
export const API_GET_CHARGE_HEADS = `${API_BASE_URL}/charge-heads`;
export const API_SAVE_CHARGE_HEAD = `${API_BASE_URL}/save-charge-head`;

export const API_ADD_FINANCE_RECORD = `${API_BASE_URL}/add-finance-record`;
export const API_UPDATE_FINANCE_RECORD = `${API_BASE_URL}/update-finance-record`;
export const API_GET_FINANCE_RECORD = `${API_BASE_URL}/get-finance-record`;




export const API_GET_FEE_BOOK_HISTORY = `${API_BASE_URL}/fee-book-history`;
export const API_PREVIEW_FEE_BOOK_TUITION = `${API_BASE_URL}/preview-fee-book-tuition`;
export const API_GET_FEE_BOOK_STUDENTS = `${API_BASE_URL}/fee-book-students`;
export const API_ATTENDANCE_REFERENCE = `${API_BASE_URL}/attendance-reference`;
export const API_ATTENDANCE_REGISTER = `${API_BASE_URL}/attendance-register`;
export const API_SAVE_ATTENDANCE_REGISTER = `${API_BASE_URL}/save-attendance-register`;
export const API_ATTENDANCE_HISTORY = `${API_BASE_URL}/attendance-history`;
export const API_ATTENDANCE_HOLIDAYS = `${API_BASE_URL}/attendance-holidays`;
export const API_SAVE_ATTENDANCE_HOLIDAY = `${API_BASE_URL}/save-attendance-holiday`;
export const API_ARCHIVE_ATTENDANCE_HOLIDAY = `${API_BASE_URL}/archive-attendance-holiday`;
export const API_ATTENDANCE_REPORT = `${API_BASE_URL}/attendance-report`;
export const API_TEACHERS = `${API_BASE_URL}/teachers`;
export const API_TEACHER_REFERENCE = `${API_BASE_URL}/teacher-reference`;
export const API_CREATE_TEACHER = `${API_BASE_URL}/create-teacher`;
export const API_UPDATE_TEACHER = `${API_BASE_URL}/update-teacher`;
export const API_TEACHER_DETAIL = `${API_BASE_URL}/teacher-detail`;
export const API_ARCHIVE_TEACHER = `${API_BASE_URL}/archive-teacher`;
export const API_RESTORE_TEACHER = `${API_BASE_URL}/restore-teacher`;
export const API_TEACHER_AUDIT_HISTORY = `${API_BASE_URL}/teacher-audit-history`;
export const API_MY_TEACHER_PROFILE = `${API_BASE_URL}/my-teacher-profile`;
export const API_TEACHER_DOCUMENT_PREVIEW = `${API_BASE_URL}/teacher-document-preview`;
export const API_TEACHER_WORKFORCE_REFERENCE = `${API_BASE_URL}/teacher-workforce-reference`;
export const API_TEACHER_ATTENDANCE_SHEET = `${API_BASE_URL}/teacher-attendance-sheet`;
export const API_SAVE_TEACHER_ATTENDANCE = `${API_BASE_URL}/save-teacher-attendance`;
export const API_SAVE_TEACHER_WORK_WEEK = `${API_BASE_URL}/save-teacher-work-week`;
export const API_TEACHER_MONTHLY_SUMMARY = `${API_BASE_URL}/teacher-monthly-summary`;
export const API_TEACHER_SALARY_CONFIGURATIONS = `${API_BASE_URL}/teacher-salary-configurations`;
export const API_SAVE_TEACHER_SALARY_CONFIGURATION = `${API_BASE_URL}/save-teacher-salary-configuration`;
export const API_ARCHIVE_TEACHER_SALARY_CONFIGURATION = `${API_BASE_URL}/archive-teacher-salary-configuration`;
export const API_TEACHER_SALARY_REPORT = `${API_BASE_URL}/teacher-salary-report`;
export const API_SAVE_TEACHER_SALARIES = `${API_BASE_URL}/save-teacher-salaries`;
export const API_APPROVE_TEACHER_PAYROLL = `${API_BASE_URL}/approve-teacher-payroll`;
export const API_MARK_TEACHER_SALARIES_PAID = `${API_BASE_URL}/mark-teacher-salaries-paid`;
export const API_VOID_TEACHER_PAYROLL = `${API_BASE_URL}/void-teacher-payroll`;
export const API_REOPEN_TEACHER_PAYROLL = `${API_BASE_URL}/reopen-teacher-payroll`;
export const API_TEACHER_PAYROLL_PAYSLIP = `${API_BASE_URL}/teacher-payroll-payslip`;
export const API_TEACHER_WORKFORCE_AUDIT = `${API_BASE_URL}/teacher-workforce-audit`;
export const API_USERS = `${API_BASE_URL}/users`;
export const API_USER_DETAIL = `${API_BASE_URL}/user-detail`;
export const API_USER_REFERENCE = `${API_BASE_URL}/user-reference`;
export const API_CREATE_USER = `${API_BASE_URL}/create-user`;
export const API_UPDATE_USER = `${API_BASE_URL}/update-user`;
export const API_SET_USER_STATUS = `${API_BASE_URL}/set-user-status`;
export const API_RESET_USER_PASSWORD = `${API_BASE_URL}/reset-user-password`;
export const API_CHANGE_MY_PASSWORD = `${API_BASE_URL}/change-my-password`;
export const API_AUDIT_HISTORY = `${API_BASE_URL}/audit-history`;
export const API_AUDIT_REFERENCE = `${API_BASE_URL}/audit-reference`;
